import { ScoreCardMetricKey } from '../../shared/types/ScoreCardMetricKey';

export const metricsTypeValues = [ScoreCardMetricKey.totalPrincipalAmount, ScoreCardMetricKey.totalLoansNumber];
